import { Card, Col, Divider, Flex, Row, Statistic } from 'antd'
import { useContext } from 'react'
import { SectionLayoutContext } from './SectionCard'

export type StatisticCardItem = {
  title: string
  value: string
}

type Props = {
  title: string
  items: StatisticCardItem[]
}

/**
 * A set of metrics. In the card layout (full-page editor drawers) they sit in a
 * titled card, laid out like the job plan's Overview: columns split by vertical
 * dividers. Elsewhere they keep the legacy row of untitled metric cards.
 */
const StatisticCards = ({ title, items }: Props) => {
  const layout = useContext(SectionLayoutContext)

  if (layout === 'card') {
    return <Card title={title}>
      <Row>
        {items.map((item, index) => <Col key={item.title} span={24 / items.length}>
          <Flex align="stretch" style={{ height: '100%' }}>
            {index > 0 && <Divider type="vertical" style={{ height: 'auto', alignSelf: 'stretch' }} />}
            <Statistic
              title={item.title}
              value={item.value}
              style={index > 0 ? { marginLeft: 16 } : undefined}
              valueStyle={{ fontWeight: 500 }}
            />
          </Flex>
        </Col>)}
      </Row>
    </Card>
  }

  return <Flex justify="space-around">
    {items.map(item => <Card key={item.title} style={{ width: '30%' }}>
      <Statistic title={item.title} value={item.value} />
    </Card>)}
  </Flex>
}

export default StatisticCards
